import * as React from "react"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import New from "../components/new"
import Seo from "../components/seo"

const JadulPage = () => (
  <New>
    <Seo title="aplikasi kasir toko minimarket,restoran cafe rumah makan,invoice akuntansi,sekolah, website mesin kasir online" />
<div className="row p-0" style={{backgroundImage: `url(${('https://mesinkasironline.web.app/img/mesinkasironlineapp1.jpg')})`
}}>
      <div className="col-12 col-md-12 p-3 p-md-5 text-center">
 <div className="p-3 p-md-5 text-white">
        <h1><strong><a href="https://mesinkasironline.web.app" className="text-white">Version 2 Mesin Kasir Online</a></strong></h1>
        <h2>A Website Application</h2>
<p>
Dukungan dengan berbagai technology untuk Solusi kebutuhan aplikasi kasir toko minimarket,aplikasi restoran cafe rumah makan, aplikasi office invoice akuntansi,applikasi sekolah, web app mesin kasir online terbaik untuk berbagai bidang bersama technology kami.
</p>
<Link to="#start" className="button shadow">Get Started Now</Link>
        </div>
</div>
    </div>
  <div className="row" id="start">
      <div className="col-12 col-md-9 p-0 border border-white text-center">
	  <StaticImage
         src="../img/mesinkasironlineapp2.jpg"
         loading="eager"
         className="img-fluid"
         width={1000}
         quality={95}
         formats={["auto"]}
         alt="mesinkasir"
       />
        </div>
      <div className="col-12 col-md-3 p-3">
      <div className="p-3 p-md-5">
      <h3><strong>Point of Sale</strong></h3>
<p>
Temukan kenyamanan bekerja dengan mesin kasir kami, sensasi full touchscreen tercipta untuk one touch system. 
  </p>
  <a href="https://mesinkasir.github.io/e-catalog/TOUCHSCREEN%20POS.pdf" className="button">Download Now</a>
        </div>
        </div>
  </div>
  <div className="row">
  <div className="col-12 col-md-4 p-3 p-md-5 text-center">
      <div className="p-3 p-md-5">
<h3><strong>RESTORAN</strong></h3>
<p>
Terbaik untuk <a href="/">mesin kasir restoran</a> dengan full touchscreen mode untuk digunakan, slim desain dan begitu unik menarik serta fashionable untuk menudukung  kebutuhan point of sale restoran cafe rumah makan anda, dengan dukungan penuh software program restoran aplikasi restoran yang complete menjadikan kesempurnaan dalam menggunakan paket set mesin kasir lengkap resto ini.
  </p>
  <Link to="/mesinkasirrestoran" className="button">More Info</Link>
        </div>
        </div>
      <div className="col-12 col-md-8 p-0 border border-white text-center">
	   <StaticImage
         src="../img/mesinkasironlineapp3.jpg"
         loading="eager"
         className="img-fluid"
         width={1000}
         quality={95}
         formats={["auto"]}
         alt="mesin kasir restoran"
       />
        </div>
  </div>
  <div className="row">
      <div className="col-12 col-md-8 p-0 border border-white text-center">	  
	  <StaticImage
         src="../img/mesinkasironlineapp4.jpg"
         loading="eager"
         className="img-fluid"
         width={1000}
         quality={95}
         formats={["auto"]}
         alt="mesin kasir"
       />
        </div>
      <div className="col-12 col-md-4 p-3 p-md-5 text-center">
      <div className="p-3 p-md-5">
<h3><strong>RETAIL</strong></h3>
<p>
Solusi terbaik untuk <a href="/">mesin kasir toko minimarket</a> dalam bekerja dengan dukungan berbagai hardware lengkap dengan paket set memudahkan dalam setiap pemilihan technology yang disesuaikan dengan kebutuhan.
  </p>
  <Link to="/mesinkasirtoko/" className="button">More Info</Link>
        </div>
        </div>
        <div className="row" id="webapp">
  <div className="col-12 col-md-4 p-3 p-md-5 text-center">
      <div className="p-3 p-md-5">
<h3><strong>WEB APPS</strong></h3>
<p>
Saat nya revolusi digital dimulai dengan <a href="/">website application</a>, dijaman aplikasi yang secara otomatis terintegrasi dengan website memudahkan dalam balutan satu apps untuk semua baik aplikasi bekerja dan pembuatan website untuk bisnis usaha.
  </p>
  <Link to="#app" className="button">Get Start</Link>
        </div>
        </div>
      <div className="col-12 col-md-8 p-0 border border-white text-center">
	   <StaticImage
         src="../img/mesinkasironlineapp5.jpg"
         loading="eager"
         className="img-fluid"
         width={1000}
         quality={95}
         formats={["auto"]}
         alt="mesin kasir"
       />
        </div>
  </div>
 </div>
 <div className="row" id="app">
      <div className="col-12 col-md-12 p-0 border border-white text-center">
	  <StaticImage
         src="../img/mesinkasironlineapp6.jpg"
         loading="eager"
         className="img-fluid"
         width={1000}
         quality={95}
         formats={["auto"]}
         alt="aplikasi restoran cafe rumah makan"
       />
        </div>
      <div className="col-12 col-md-12 p-3 p-md-5 text-center">
      <div className="p-3 p-md-5">
<h3><strong><a href="/">APLIKASI RESTORAN</a></strong></h3>
<p>
Memanjakan para penguasaha kuliner khusus nya restoran rumah makan cafe dengan penggunaan aplikasi resto online ini , sangat mudah digunakan lengkap dengan berbagai dukungan module, hingga integrasi secara detail dengan website application plus android APK menjadi lebih baik dengan menggunakan resto apps ini, banyak variant yang telah kami deploy untuk kemudahan pemilihan apps sesuai dengan kebutuhan usaha kulienr fastfood maupun system waiters kitchen kasir admin dalam penerpaan nya
  </p>
  <Link to="/aplikasirestoran/" className="button">More Info</Link>
        </div>
        </div>
        </div>
        <div className="row">
      <div className="col-12 col-md-12 p-0 border border-white text-center">
	   <StaticImage
         src="../img/mesinkasironlineapp7.jpg"
         loading="eager"
         className="img-fluid"
         width={1000}
         quality={95}
         formats={["auto"]}
         alt="mesin kasir"
       />
        </div>
      <div className="col-12 col-md-12 p-3 p-md-5 text-center">
      <div className="p-3 p-md-5">
<h3><strong><a href="/">APLIKASI TOKO</a></strong></h3>
<p>
Solusi terbaik untuk usaha retail dan grosir dengan menggunakan aplikasi kasir toko online dalma bekerja , dengan kemampuan terbaik menjadikan kemudahan bagi pelaku bisnis usaha retail dan grosir untuk menjalankan aktivitas bisnis nya, memudahkan dengan berbagai pilihan apps tersedia untuk digunakan sesuai dengan kebutuhan mulai touchscreen penjualan bergambar hingga barcode sytsem semakin mobile dalam penggunaan aplikasi kasir toko online.
  </p>
  <Link to="/aplikasitoko/" className="button">More Info</Link>
        </div>
        </div>
        </div>
        <div className="row">
      <div className="col-12 col-md-12 p-0 border border-white text-center">
	   <StaticImage
         src="../img/mesinkasironlineapp8.jpg"
         loading="eager"
         className="img-fluid"
         width={1000}
         quality={95}
         formats={["auto"]}
         alt="mesin kasir"
       />
        </div>
      <div className="col-12 col-md-12 p-3 p-md-5 text-center">
      <div className="p-3 p-md-5">
<h3><strong><a href="/">APLIKASI SEKOLAH</a></strong></h3>
<p>
Kebutuhan terbaik untuk dunia pendidikan dalam kebutuhan sebuah web apps sekolah untuk digunakan baik e-learn media, simple hingga premium plus ERP , pembayaran sekolah rapot online dan berbagai apps sekolah lain nya memudahkan proses belajar mengajar hingga kebutuhan pembukuan sekolah secara detail dan terperinci.
  </p>
  <Link to="/aplikasisekolah" className="button">More Info</Link>
        </div>
        </div>
        </div>
        <div className="row">
      <div className="col-12 col-md-12 p-0 border border-white text-center">
	   <StaticImage
         src="../img/mesinkasironlineapp9.jpg"
         loading="eager"
         className="img-fluid"
         width={1000}
         quality={95}
         formats={["auto"]}
         alt="mesin kasir"
       />
        </div>
      <div className="col-12 col-md-12 p-3 p-md-5 text-center">
      <div className="p-3 p-md-5">
<h3><strong><a href="/">APLIKASI OFFICE</a></strong></h3>
<p>
Solusi untuk kebutuhan perkantoran office dengan kebutuhan aplikasi invoice dengan pencatatan tender project yang dikerjakan proses pembayaran pelanggan, kebutuhan percetakan faktur penjualan dan faktur pajak, plus akuntansi untuk digunakan dalam mendukung bisnis anda.
  </p>
  <Link to="/aplikasioffice/" className="button">More Info</Link>
        </div>
        </div>
        </div>
        <div className="row" id="website">
      <div className="col-12 col-md-12 p-0 border border-white text-center">
	   <StaticImage
         src="../img/mesinkasironlineapp10.jpg"
         loading="eager"
         className="img-fluid"
         width={1000}
         quality={95}
         formats={["auto"]}
         alt="mesin kasir"
       />
        </div>
      <div className="col-12 col-md-12 p-3 p-md-5 text-center">
      <div className="p-3 p-md-5">
<h3><strong><a href="/">WEBSITE + ANDROID APK</a></strong></h3>
<p>
Layanan pembuatan website modern dengan berbagai technology baik content management system dan framework untuk kebutuhan build dan deploy modern website terbaru untuk berbagai kebutuhan seperti company profile, toko shop, restoran cafe rumah makan, sekolah edukasi, dan berbagai bidang usaha lain nya.
<br/>Dan layanan pembuatan APK android untuk kebutuhan upload playstore google menjadi pilihan terbaik era milenial saat ini.
  </p>
<Link to="/pembuatanwebsite/" className="button">Website Info</Link> <Link to="/aplikasiandroid/" className="button">Android Info</Link>
        </div>
        </div>
        </div>
        <div className="row">
      <div className="col-12 col-md-3 p-0 border border-white text-center">
	  <StaticImage
         src="../img/mesinkasironlineapp12.jpg"
         loading="eager"
         className="img-fluid"
         width={1000}
         quality={95}
         formats={["auto"]}
         alt="mesin kasir"
       />
        </div>
          <div className="bg-light col-12 col-md-9 p-3 p-md-5 text-center">
      <div className="p-3 p-md-5">
      <h3>Contact Us</h3>
<a href="https://wa.me/6285646104747" className="button border border-light">Chat Now</a>
<a href="tel:+6285331361404" className="button border border-light">Call Us</a>
<a href="mailto:hockeycorpmarketing@gmail.com" className="button border border-light">Email</a><br/>
<Link to="/eng/">English Version</Link> or <Link to="/page-2/">Old School</Link>
        </div>
        </div>
        </div>
  </New>
)

export default JadulPage
